import { useState } from "react";
import { useUpdateEffect } from "react-use";

const PasswordInput = ({
  id,
  placeholder,
  value,
  className,
  onBlur,
  onChange,
}) => {
  const [isAvailable, setAvailable] = useState(false);
  const [msg, setMessage] = useState("");
  // 비밀번호 유효성 검사 함수
  const validatePassword = (password) => {
    const score = ["[a-z]", "[A-Z]", "[!@#$%^&*,.?]", "[0-9]"].reduce(
      (ac, cu) => {
        const result = new RegExp(cu, "g").test(password);
        return result ? ac + 1 : ac;
      },
      0
    );
    return score > 1 && password.length > 7;
  };

  const handleBlur = (e) => {
    onBlur && onBlur(e);
  };

  useUpdateEffect(() => {
    if (validatePassword(value)) {
      setMessage("");
      setAvailable(true);
    } else {
      setMessage(
        "비밀번호는 영문 소문자 및 대문자, 숫자, 특수문자(!@#$%^&*,.?)를 두가지 이상 조합하여 8자 이상 입력하세요."
      );
      setAvailable(false);
    }
  }, [value]);
  return (
    <div className="form-control w-full">
      <input
        id={id}
        type="password"
        placeholder={placeholder || "비밀번호"}
        className={`input input-bordered${
          isAvailable ? " border-primary" : ""
        } ${className || ""}`}
        onChange={onChange}
        onBlur={handleBlur}
        value={value}
      />
      <div className="flex flex-col mt-1">
        {value && !isAvailable && (
          <span className="text-sm text-left text-red-500">{msg}</span>
        )}
        {value && isAvailable && (
          <span className="text-sm text-left text-green-500">{msg}</span>
        )}
      </div>
    </div>
  );
};

export default PasswordInput;
